/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const taxonomies = {
    /**
     * Roles
     */
    roles: {
        codename: 'roles',
        id: 'aded6198-49fe-4a8f-88b3-33ad3c965da1',
        externalId: undefined,
        name: 'Roles',
        terms: {
            caddie: {
                codename: 'caddie',
                id: 'e9906492-1259-4534-9fc2-bce292581f8d',
                externalId: undefined,
                name: 'Caddie',
                terms: {}
            },
            lcq___caddie: {
                codename: 'lcq___caddie',
                id: '4ccae9f7-17fd-483a-ba36-430a0cdd18d6',
                externalId: undefined,
                name: 'LCQ - Caddie',
                terms: {}
            },
            lcq___manager: {
                codename: 'lcq___manager',
                id: '04462ca8-3893-40df-b55e-848e148eeab9',
                externalId: undefined,
                name: 'LCQ - Manager',
                terms: {}
            },
            lcq___player: {
                codename: 'lcq___player',
                id: '2486dcb8-1863-4bcd-a5b6-f278c283d82a',
                externalId: undefined,
                name: 'LCQ - Player',
                terms: {}
            },
            manager: {
                codename: 'manager',
                id: '22f091aa-581f-4a1a-8673-2576a3681568',
                externalId: undefined,
                name: 'Manager',
                terms: {}
            },
            player: {
                codename: 'player',
                id: 'f189a0c3-31a7-45f4-982f-de6db64162d8',
                externalId: undefined,
                name: 'Player',
                terms: {}
            },
            randaadmin: {
                codename: 'randaadmin',
                id: '53587f95-a9a0-4875-91d8-c0a2e152c1c8',
                externalId: undefined,
                name: 'RandaAdmin',
                terms: {}
            }
        }
    }
} as const;
